import React from 'react'
import SideBar from '@/shared/components/SideBar/SideBar'
import Header from '@/shared/components/Header/Header'

import ChatBot from '@/shared/components/ChatBot/ChatBot'
import styles from '../PageLayout.module.scss'
import CropImageModal from '@/shared/components/Modal/CropImageModal/CropImageModal'

type PageLayoutProps = {
  children: React.ReactNode
}

function PageLayout({ children }: PageLayoutProps) {
  return (
    <div className={styles.protectedPageLayout}>
      <SideBar />
      <Header />
      {children}
      <ChatBot />
      <CropImageModal />
    </div>
  )
}

export default PageLayout
